import React, { useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { UserPlusIcon } from "../common/icons/Solid";
import { Actions as ACTIONS } from "../../store/actions/permissionActions";
import Spinner from "../common/Spinner";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { useEffect } from "react";

const InviteManagerModal = ({ isModalOpen, closeModal, sendInvite, sendingInvite, inviteSent }) => {
	const { register, handleSubmit, control, watch, setValue } = useForm();
	const [email, setEmail] = useState("");

	let emailSchema = yup.object().shape({
		email: yup.string().required().email(),
	});

	useEffect(() => {
		if (!isModalOpen) setEmail("");
	}, [isModalOpen]);

	if (!isModalOpen) {
		return null;
	}

	const onSubmit = (data) => {
		emailSchema
			.isValid({
				email,
			})
			.then((valid) => {
				if (valid) {
					data.email = email;
					sendInvite(data);
				} else {
					NotificationManager.error("Email is invalid, please check your input", "Inviting Manager");
				}
			});
	};

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "50%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title pull-left">Invite Manager</h3>
						</div>
					</div>
					<div
						className="block-content"
						style={{ padding: 20 }}
					>
						{inviteSent ? (
							<p>Your Invite has been sent successfully</p>
						) : (
							<form onSubmit={handleSubmit(onSubmit)}>
								<div
									className="col-sm-6 pl-0"
									style={{ marginTop: 20 }}
								>
									<div className="form-material">
										<label htmlFor="name">First Name</label>
										<input
											className="form-control form-input"
											ref={register}
											id="name"
											name="name"
											required="required"
											autoComplete="off"
										/>
									</div>
								</div>

								<div
									className="col-sm-6 pl-0"
									style={{ marginTop: 20 }}
								>
									<div className="form-material">
										<label htmlFor="surname">Last Name</label>
										<input
											ref={register}
											className="form-control form-input"
											id="surname"
											name="surname"
											required="required"
											autoComplete="off"
										/>
									</div>
								</div>

								<div className="clearfix" />

								<div
									className="col-sm-6 pl-0"
									style={{ marginTop: 20 }}
								>
									<div className="form-material">
										<label htmlFor="email">Email</label>
										<input
											className="form-control form-input"
											value={email}
											id="email"
											type="email"
											required="required"
											onChange={(e) => {
												setEmail(e.target.value.replace(/\s/g, ""));
											}}
											autoComplete="off"
										/>
									</div>
								</div>

								<div className="clearfix" />

								<button
									className="btn btn-success right"
									type="submit"
									style={{ marginTop: 20 }}
								>
									{sendingInvite ? (
										<Spinner
											style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
											className="animate-spin -ml-1 mr-3 h-5 w-5 "
										/>
									) : (
										<UserPlusIcon style={{ height: "1.5em", float: "left" }} />
									)}
									<div style={{ float: "left", paddingLeft: 5 }}>
										{sendingInvite ? "Sending" : "Send Invite"}
									</div>
								</button>
							</form>
						)}
						<div className="clearfix" />
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		isModalOpen: state?.permissions?.inviteManagerModal,
		sendingInvite: state?.permissions?.sendingInvite,
		inviteSent: state?.permissions?.inviteSent,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(ACTIONS.inviteManagerModal(false)),
	sendInvite: (data) => dispatch(ACTIONS.inviteManager(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteManagerModal);
